export default __webpack_public_path__ + "images/97aef6cd93d1a39d06804a85033eb3e4.png";